import * as R from 'ramda';
export default (tableFlag, columnFlag) => R.isNil(columnFlag) ? tableFlag : columnFlag;
